import { Nav, Tab } from "react-bootstrap";
import { IComplaintDetails } from "../../../api/IComplaint";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import { NonCompliancesGrid } from "../../../leap-components/NonCompliances/NonCompliancesGrid";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  complaintDetails: IComplaintDetails;
  licenceProfile: ILicenceProfile;
}

interface RelatecComplianceProps {
  complaintDetails: IComplaintDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  complaintDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="non-compliances">Non Compliances</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="non-compliances">
          <NonCompliancesGrid
            relatedRecordType="Complaint"
            relatedRecordId={complaintDetails.complaintid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  complaintDetails,
  licenceProfile,
}: RelatecComplianceProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="non-compliances"
      complaintDetails={complaintDetails}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
